export default __webpack_public_path__ + "static/media/banner1.b7b8e319.jpg";